import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Divider } from '@material-ui/core';

import TableRegister from '../../components/TableRegister';

import { useStyles } from './style';
import api from '../../services/api';
import Colors from '../../components/Colors';

interface User {
  id: number;
  email: string;
  groups: string[];
}

const MyAccount: React.FC = () => {
  const styles = useStyles();
  const [usuario, setUsuario] = useState({
    id: 0,
    email: '',
    adm: '',
    groups: [''],
    token: '',
  });

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  useEffect(() => {
    async function loadUser() {
      const user = await api.get<User>(`/api/users/${localStorage.getItem('id')}/`, {
        headers: authHeader,
      });

      const admin = user.data.groups.find((group: string) => {
        if (group === 'admin') {
          return group;
        }
        return null;
      });

      setUsuario({
        id: user.data.id,
        adm: admin ? 'Sim' : 'Não',
        email: user.data.email,
        groups: user.data.groups,
        token: authHeader.Authorization,
      });
    }
    loadUser();
  }, [authHeader]);

  return (
    <Container className={styles.container}>
      <div className={styles.top}>
        <Typography variant="h5" gutterBottom style={{ marginTop: '2%' }}>
          Informações da conta
        </Typography>
        <Link to='/alterarsenha' style={{display:'flex',alignItems:'center',textDecoration:'none'}}>
          <Typography variant="subtitle1" gutterBottom style={{marginTop:'30%',color:Colors.main}}>
            Alterar Senha
          </Typography>
        </Link>
      </div>
      <Divider />
      <Container className={styles.root}>
        <TableRegister
          title={['IDENTIFICADOR DO USUÁRIO', 'E-MAIL']}
          data={[
            {
              details: [`${usuario.id}`, `${usuario.email}`],
            },
          ]}
        />
        <TableRegister
          title={['ADMINISTRADOR?', 'GRUPOS']}
          data={[
            {
              details: [`${usuario.adm}`, `${usuario.groups.join(', ')}`],
            },
          ]}
        />
      </Container>
    </Container>
  );
};

export default MyAccount;
